<template>
  <div v-if="show">
    <loading :loading="loading"></loading>
    <error-alert-item
      :logout-on-network-error="false"
      :error-alert-event="errorAlertEvent"
      :network-error="networkError"
      @resetErrorAlertEvent="errorAlertEvent=false">
    </error-alert-item>

    <refresh-item
      :show="showRefreshItem"
      @onRefresh="onRefresh"
      ></refresh-item>

    <div v-if="showUI && !showRefreshItem">
      <div class="margin-left-20 margin-right-20 text-align-center">
        <weex-text class="font-size-sm-base">{{ continueWithExistingLoan }}</weex-text>
      </div>

      <div>
        <wxc-button
          size="small"
          type="blue"
          text="Apply New Loan"
          :btn-style="applyNewLoanButtonStyle"
          class="item-align-right1"
          @wxcButtonClicked="onApplyNewLoan"
          ></wxc-button>
      </div>

      <div class="margin-top-60">
        <div
          v-for="ezLoan in ezLoans"
          :key="ezLoan.loan.id"
          >
          <loan-item
            class="margin-top-10 margin-bottom-10 margin-left-20 margin-right-20 background-color-white"
            :ez-loan="ezLoan"
            @onLoanSelected="onContinueWithExistingLoan"
            ></loan-item>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Loading from "./Loading";
  import ErrorAlertItem from "./ErrorAlertItem";
  import RefreshItem from "./RefreshItem";
  import LoanItem from "./LoanItem";
  import DataSource from "../../data/DataSource";
  import WxcButton from "../../../weex-ui/packages/wxc-button/index";
  import EzUtils from "../../utils/EzUtils";
  import LoanScopeDataHolder from "../../data/model/LoanScopeDataHolder";
import { Constants } from '../Constants';

  export default {
    name: "AppliedLoansCheckItem",
    components: { Loading, ErrorAlertItem, RefreshItem, LoanItem, WxcButton },
    data: () => ({
      showRefreshItem: false,
      showUI: false,
      loading: false,
      errorAlertEvent: false,
      networkError: {},
      ezLoans: [],
      fetchedRetailerShortName: null
    }),

    props: {
      show: {
        type: Boolean,
        required: true,
        default: false
      },

      retailerShortName: {
        type: String,
        default: ""
      },

      officeExternalId: {
        type: String,
        default: ""
      }
    },

    methods: {
      showError(error) {
        this.loading = false;
        this.networkError = error;
        this.errorAlertEvent = true;
      },

      resetDataAndViews() {
        this.showRefreshItem = false;
        this.showUI = false;
        this.loading = false;
        this.errorAlertEvent = false;
        this.networkError = {};
        this.ezLoans = [];
        this.fetchedRetailerShortName = null;
      },

      onRefresh() {
        this.fetchPartnerConfigIfNeeded();
      },

      onApplyNewLoan() {
        this.$emit("onApplyNewLoan")
      },

      onContinueWithExistingLoan(ezLoan) {
        this.$emit("onContinueWithExistingLoan", ezLoan.loan.id)
      },

      checkForAvailableLoans() {
        this.resetDataAndViews();
        this.fetchPartnerConfigIfNeeded();
      },

      fetchPartnerConfigIfNeeded() {
        if (!this.retailerShortName && this.officeExternalId) {
          DataSource.getRetailerConfig({ officeExternalId: this.officeExternalId })
            .then(partnerConfigRes => {
              if (partnerConfigRes.errorOccurred) {
                this.showError(partnerConfigRes.data);
                this.showRefreshItem = true;
              } else {
                this.loading = false;
                this.fetchedRetailerShortName = partnerConfigRes.data.retailerName;
                this.fetchLoans();
              }
            })
        } else {
          this.fetchLoans();
        }
      },

      fetchLoans() {
        this.loading = true;
        DataSource.getLoansForStages(null, null, null, null, "id", "DESC", null, null, Constants.LOAN_APPLICACTION_TYPE_MAIN)
          .then(loansData => {
            this.loading = false;
            if (loansData.errorOccurred) {
              this.showError(loansData.data);
              this.showRefreshItem = true;
            } else {
              this.ezLoans = this.filterLoanForRetailerIfRetailerNameIsPresent(loansData.data);
              if (this.ezLoans.length > 0) {
                if (LoanScopeDataHolder.isOnboardingLoan()) {
                  this.onContinueWithExistingLoan(this.ezLoans[0]);
                } else {
                  this.showUI = true;
                }
              } else {
                this.onApplyNewLoan();
              }
            }
          })
      },

      filterLoanForRetailerIfRetailerNameIsPresent(ezLoans) {
        const retailerShortName = this.retailerShortName ? this.retailerShortName
          : this.fetchedRetailerShortName;
        if (retailerShortName) {
          let filteredLoans = [];
          ezLoans && ezLoans.forEach(ezLoan => {
            if (ezLoan
              && ezLoan.loanDetails
              && EzUtils.areEqualString(retailerShortName, ezLoan.loanDetails.retailer_short_name)
            ) {
              filteredLoans.push(ezLoan);
            }
          });
          return filteredLoans;
        } else {
          return ezLoans;
        }
      }
    },

    computed: {
      continueWithExistingLoan() {
        if (this.ezLoans.length > 1) {
          return "There are already existing loans. Click on a loan to continue rest of the steps or click button below to apply a new loan.";
        } else {
          return "There is already a existing loan. Click on the loan to continue rest of the steps or click button below to apply a new loan.";
        }
      },

      applyNewLoanButtonStyle() {
        return { width: "120px" };
      }
    }
  }
</script>


<style
  scoped
  src="../../assets/style/base.css"></style>
